import { DataWrapper } from '@app/components/DataWrapper';
import { ResourceCard } from '@app/components/ResourceCard';
import { useAuth } from '@app/hooks/useAuth';
import {
  ContentData,
  getFinacilaLiteracy,
} from '@app/services/otherContentService';
import { Card, Grid } from '@mui/material';
import { ListItemActions } from './ListItemActions';

export function ListView() {
  const { isAdmin } = useAuth();

  return (
    <DataWrapper<ContentData>
      id="financial-literacy"
      title="Financial Literacy"
      filterConfig={[]}
      fetchData={getFinacilaLiteracy}
      render={data => (
        <Grid container spacing={4} px={{ xs: 2, lg: 4 }}>
          {data.map(row => (
            <Grid key={row.id} item xs={12} md={12} lg={6} xl={4}>
              <Card
                variant="outlined"
                sx={{ height: 1, display: 'flex', flexDirection: 'column' }}
              >
                <ResourceCard
                  title={row.title}
                  description={row.description}
                  image={row.image}
                  url={row.url}
                  youtubeUrl={row.youtubeUrl}
                  btnText={row.btnText}
                />
                {isAdmin && <ListItemActions data={row} />}
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    />
  );
}
